import { SearchType } from '@src/quince-site-common/src/services/orderAggregatorService/orderAggregatorService.types'

export interface SearchOptionsPayload {
  searchType: SearchType
  orderNumber?: string
  zipCode?: string
  paymentCardSuffix?: string
  page: number
  size: number
}

export enum ResourceEntityType {
  CUSTOMER = 'CUSTOMER',
  FIND_ORDER = 'FIND_ORDER',
}
